import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

import { setTitle } from '../services/title.service';

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

setTitle('Home');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("h1", null, "Welcome", -1)
  ])))
}
}

})